import ActivityType from "types/ActivityType";
import { ActivitySerializersActivity } from "types/serializers";
import Activity from "./Activity";

export interface Props {
  activities: ActivitySerializersActivity[];
  offset?: number;
}

export default function ActivityFeed({
  activities,
  offset = 0,
}: Props) {
  return (
    <div className="relative md:px-2">
      {activities.length === 0 ? (
        <p className="p-6 text-center">No activities were found</p>
      ) : (
        <>
          {activities.map((activity, index) => (
            <Activity
              key={`activity-${activity.id}`}
              activity={activity as ActivityType}
              position={offset+index}
            />
          ))}
        </>
      )}
    </div>
  );
}
